import React from 'react';
import { describe } from '@elliemae/ds-legacy-props-helpers';
import PopperImpl from './PopperImpl.js';
import { Position } from './positions.js';
import { Interaction } from './interaction.js';
import { popperProps, defaultProps } from './props.js';

const DSPopper = ({
  containerProps,
  arrowGap,
  arrowSize,
  blockName,
  contentOffset,
  contentStyle,
  contentComponent,
  delayClose,
  delayOpen,
  interactionType,
  isOpen, // if this is set DSPopper would be a controlled component if not, an uncontrolled one
  onOpen,
  onClose,
  onPlacementChange,
  placement,
  preventOverflow,
  showArrow,
  closeAnimationConfig,
  openAnimationConfig,
  usePortal,
  triggerComponent,
  wrapExtraComponent,
  getTargetFromChildren,
  getContentFromChildren,
  modifiers,
  triggerRef,
  children: customPopper,
  renderReference,
  referenceNode,
  zIndex,
  hideIfNotVisible,
}): JSX.Element => (
  <PopperImpl
    arrowGap={arrowGap}
    arrowSize={arrowSize}
    blockName={blockName}
    closeAnimationConfig={closeAnimationConfig}
    containerProps={containerProps}
    contentComponent={contentComponent}
    contentOffset={contentOffset}
    contentStyle={contentStyle}
    delayClose={delayClose}
    delayOpen={delayOpen}
    getContentFromChildren={getContentFromChildren}
    getTargetFromChildren={getTargetFromChildren}
    interactionType={interactionType}
    isOpen={isOpen}
    modifiers={modifiers}
    onOpen={onOpen}
    onClose={onClose}
    onPlacementChange={onPlacementChange}
    openAnimationConfig={openAnimationConfig}
    placement={placement}
    preventOverflow={preventOverflow}
    referenceNode={referenceNode}
    renderReference={renderReference}
    showArrow={showArrow}
    triggerComponent={triggerComponent}
    triggerRef={triggerRef}
    usePortal={usePortal}
    wrapExtraComponent={wrapExtraComponent}
    zIndex={zIndex}
    hideIfNotVisible={hideIfNotVisible}
  >
    {customPopper}
  </PopperImpl>
);

// @deprecated: There's the NEW (not finished) popover that uses its own popper implementation.
DSPopper.propTypes = popperProps;
DSPopper.defaultProps = defaultProps;
DSPopper.displayName = 'DSPopper';
const DSPopperWithSchema = describe(DSPopper);
DSPopperWithSchema.propTypes = popperProps;

export { Interaction as PopperInteractions, Position as PopperPositions, DSPopperWithSchema, DSPopper };

export { interactions } from './interaction.js';
export { positions } from './positions.js';

export default DSPopper;
